import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { BaseTaskListComponent } from '../base-task-list/base-task-list.component';
import { AuthService } from '../../../services/auth.service';
import { TaskSearchConfig } from '../../../models/task';
import { AclService } from '../../../services/acl.service';
import { CamelCaseToTitleCasePipe } from '../../../pipes/camel-case-to-title-case.pipe';

@Component({
  selector: 'other-task-list',
  templateUrl: './other-task-list.component.html',
  styleUrls: ['./other-task-list.component.css'],
  standalone: false
})
export class OtherTaskListComponent extends BaseTaskListComponent implements AfterViewInit {
  @Input() searchConfig: TaskSearchConfig;
  @Output() onSetTaskContainer: EventEmitter<ElementRef> = new EventEmitter();
  @ViewChild('otherTaskContainer') otherTaskContainer: ElementRef;

  constructor(
    public aclService: AclService,
    public authService: AuthService,
    public camelToTitleCasePipe: CamelCaseToTitleCasePipe
  ) {
    super(authService, camelToTitleCasePipe);
  }

  ngAfterViewInit(): void {
    // pass the container's element ref to the parent
    // so scroll can be reset on task view change
    this.onSetTaskContainer.emit(this.otherTaskContainer);
  }
}
